module.exports = __webpack_public_path__ + "img/softinya-3.c58ce60b.png";